/** @format */

import { useEffect, useRef, useState } from 'react';

import moment from 'moment';

import { useGlobal, setGlobal } from 'reactn';
import { Row, Col, Form, Select, Modal, Divider } from 'antd';

import Images from '../../../../../../components/Commons/Images';
import { rulesValidation } from '../../../../../../components/Commons/Input/rules';

import ModalLocalSelected from '../ModalLocalSelected';

import { ENV_IMG } from '../../../../../../components/Commons/Hooks/Variables/Enviroment';

import './style.scss';
import DescriptionPrices from '../../../../components/PaymentDetailService/components/DescriptionPrices';
import { GlobalConsumer } from '../../../../../../components/Commons/Context/Global';
import { pharmacyFeatures } from '../../../../../../v2-config/constants/pharmacy-features.constant';

export default function LocalByDateSelect(props) {
	const [isVisible, setVisible] = useState(null);
	const [isPreviewLocal, setPreviewLocal] = useState(null);
	const [modalHelp, setModalHelp] = useState(false);
	const [isRecalculatingDelivery, setRecalculatingDelivery] = useGlobal('isRecalculatingDelivery');
	const previousCheckoutRef = useRef(props.checkout);
	const [isDeliveryPrices] = useGlobal('deliveryPrices');
	const [isRetirementData] = useGlobal('retirementData');
	const [isAddressValidated] = useGlobal('isAddressValidated');
	const { isSelectedDeliveryType } = GlobalConsumer();
	const { isMobile } = GlobalConsumer();
	const [globalSelectedDate] = useGlobal('selectedDate');

	// const i = props.index;

	console.log('props en select', props);

	const specialSchedule = isRetirementData.locals[0].special_schedule ? isRetirementData.locals[0].special_schedule : [];

	let regularSchedule;

	const activeOverride = specialSchedule.find((sch) => sch && sch.status === true);

	if (activeOverride && activeOverride.original_daily_schedules) {
		regularSchedule = activeOverride.original_schedule;
	} else {
		regularSchedule = isRetirementData?.locals?.[0]?.schedule ?? [];
	}

	const getAvailableDateRanges = (count = 7) => {
		const closedSet = {};

		for (let s = 0; s < specialSchedule.length; s++) {
			const sch = specialSchedule[s];
			if (!sch?.applies_to_days?.length) continue;
			if (!sch.reason?.includes('Cerrado')) continue;

			const startDay = moment.unix(sch.start).utc().startOf('day');
			const endDay = moment.unix(sch.end).utc().startOf('day');

			for (let d = moment(startDay); d.diff(endDay) <= 0; d.add(1, 'days')) {
				closedSet[d.format('DD/MM/YYYY')] = true;
			}
		}

		const closedWeekdays = new Set();
		regularSchedule.forEach((r) => {
			if (typeof r.open === 'string' && r.open.toUpperCase() === 'CERRADO') {
				closedWeekdays.add(Number(r.day)); // 0-6
			}
		});

		const isBusinessOpenDay = (dayMoment) => {
			const formatted = dayMoment.format('DD/MM/YYYY');
			const weekDayNum = dayMoment.day(); // 0=domingo, 6=sábado

			if (weekDayNum === 0 || weekDayNum === 6) return false;
			if (closedSet[formatted]) return false;
			if (closedWeekdays.has(weekDayNum)) return false;

			return true;
		};

		const addBusinessDays = (fromDate, businessDays) => {
			let d = fromDate.clone();
			let added = 0;
			while (added < businessDays) {
				d.add(1, 'day');
				if (isBusinessOpenDay(d)) {
					added++;
				}
			}
			return d;
		};

		const now = moment();
		const orderDay = now.clone().startOf('day');

		// same-day: un día por opción; corte/sábado según pharmacyFeatures
		if (pharmacyFeatures.sameDayDeliveryDates) {
			const saturdayCutoff = pharmacyFeatures.sameDaySaturdayCutoffHour;
			const weekdayCutoff = pharmacyFeatures.sameDayWeekdayCutoffHour ?? 14;

			const isSameDayDeliverable = (dayMoment) => {
				const formatted = dayMoment.format('DD/MM/YYYY');
				const weekDayNum = dayMoment.day();

				if (weekDayNum === 0) return false;
				if (weekDayNum === 6 && saturdayCutoff == null) return false;
				if (closedSet[formatted]) return false;
				if (closedWeekdays.has(weekDayNum)) return false;

				return true;
			};

			const addSameDayDeliverableDays = (fromDate, daysToAdd) => {
				let d = fromDate.clone();
				let added = 0;
				while (added < daysToAdd) {
					d.add(1, 'day');
					if (isSameDayDeliverable(d)) {
						added++;
					}
				}
				return d;
			};

			const todayWeekday = orderDay.day();
			const cutoffHour = todayWeekday === 6 ? saturdayCutoff : weekdayCutoff;
			const isAfterCutoff = cutoffHour == null || now.hour() >= cutoffHour;

			let firstDeliveryDay;
			if (isSameDayDeliverable(orderDay) && !isAfterCutoff) {
				firstDeliveryDay = orderDay.clone();
			} else {
				firstDeliveryDay = addSameDayDeliverableDays(orderDay, 1);
			}

			const days = [];
			let current = firstDeliveryDay.clone();
			while (days.length < count) {
				if (!isSameDayDeliverable(current)) {
					current = addSameDayDeliverableDays(current, 1);
					continue;
				}
				days.push({
					start: current.format('DD/MM/YYYY'),
					end: null,
				});
				current.add(1, 'day');
			}
			return days;
		}

		const weekday = orderDay.day(); // 0=domingo, 6=sábado

		const provider = isRetirementData?.shipping_information?.delivery_provider;
		const isPharolGo = typeof provider === 'string' && provider.toLowerCase() === 'pharolgo';

		const baseBusinessDays = isPharolGo ? 2 : 3;

		const cutoffHour = 15;
		const isAfterCutoff = now.hour() >= cutoffHour;
		const isWeekend = weekday === 0 || weekday === 6;

		let startDate = orderDay.clone();

		if (isWeekend) {
			startDate = addBusinessDays(orderDay, 1);
		} else if (isAfterCutoff) {
			startDate = addBusinessDays(orderDay, 1);
		}

		let firstDeliveryDay = addBusinessDays(startDate, baseBusinessDays);

		const ranges = [];
		let currentStart = firstDeliveryDay.clone();

		while (ranges.length < count) {
			if (!isBusinessOpenDay(currentStart)) {
				currentStart = addBusinessDays(currentStart, 1);
				continue;
			}

			const currentEnd = addBusinessDays(currentStart, 1);

			ranges.push({
				start: currentStart.format('DD/MM/YYYY'),
				end: currentEnd.format('DD/MM/YYYY'),
			});

			currentStart = currentEnd.clone();
		}

		return ranges;
	};

	const dateRanges = getAvailableDateRanges();

	const handleModalPharmacyInfo = (item) => {
		if (item) {
			setVisible(true);
			setPreviewLocal(item);
		} else {
			setVisible(false);
			setPreviewLocal(null);
		}
	};

	const [timers, setTimers] = useState([]);

	useEffect(() => {
		const onBeforeUnload = () => setGlobal({ selectedDate: null });
		window.addEventListener('beforeunload', onBeforeUnload);
		return () => window.removeEventListener('beforeunload', onBeforeUnload);
	}, []);

	const handleDateSelected = (value) => {
		console.log('Selected date:', value);
		setGlobal({ selectedDate: value }); // Guardar la fecha seleccionada en el estado global para que otros componentes puedan acceder a ella
		const selected = moment(value, 'DD/MM/YYYY');
		const weekday = selected.day();
		const isToday = selected.isSame(moment(), 'day');
		const now = moment();

		const activeOverride = specialSchedule.find((sch) => sch?.status === true);
		const sourceDaily = activeOverride ? activeOverride.original_schedule : regularSchedule;

		const daily = sourceDaily?.find((d) => Number(d.day) === weekday) ?? null;

		const dateOverride = specialSchedule.find((sch) => {
			if (sch?.reason !== 'Cambio de Horario' && sch?.reason !== 'Farmacia de turno') {
				return false;
			}
			const selectedDayUTC = selected.clone().utc().startOf('day');
			const startDayUTC = moment.unix(sch.start).utc().startOf('day');

			const endUTC = moment.unix(sch.end).utc();
			const isMidnight = endUTC.hours() === 0 && endUTC.minutes() === 0 && endUTC.seconds() === 0;

			const endDayExclusiveUTC = isMidnight ? endUTC.startOf('day') : endUTC.clone().add(1, 'day').startOf('day');

			return selectedDayUTC.isSameOrAfter(startDayUTC) && selectedDayUTC.isBefore(endDayExclusiveUTC);
		});

		let openStr, closeStr;

		if (dateOverride && dateOverride.override_open && dateOverride.override_close) {
			openStr = dateOverride.override_open;
			closeStr = dateOverride.override_close;
		} else if (daily) {
			openStr = daily.open;
			closeStr = daily.close;
		} else {
			setTimers([]);
			return;
		}

		if (!openStr || !closeStr || openStr.toUpperCase() === 'CERRADO' || closeStr.toUpperCase() === 'CERRADO') {
			setTimers([]);
			return;
		}

		const openM = moment(openStr, 'HH:mm:ss');
		const closeM = moment(closeStr, 'HH:mm:ss');

		if (!openM.isValid() || !closeM.isValid() || !openM.isBefore(closeM)) {
			setTimers([]);
			return;
		}

		const newTimers = [];
		let cur = openM.clone();

		while (cur.isBefore(closeM)) {
			const blockStart = cur.clone();
			const blockFinish = cur.clone().add(1, 'hour');

			if (!isToday || blockStart.isAfter(now)) {
				newTimers.push({
					start: blockStart.format('HH:mm'),
					finish: blockFinish.format('HH:mm'),
				});
			}
			cur.add(1, 'hour');
		}

		setTimers(newTimers);
	};

	const handleDeliverySelect = (item, data) => {
		timers.forEach((element) => {
			if (item === `${element.start} - ${element.finish}`) {
				const deliveryPrices = { ...isDeliveryPrices, [data]: props.group.payment.delivery };
				setGlobal({ deliveryPrices: deliveryPrices });
			}
		});
	};

	useEffect(() => {
		if (globalSelectedDate) {
			props.form.setFieldsValue({ [`date_schedule_${props.group.name}`]: globalSelectedDate });
		}
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, [globalSelectedDate, props.group.name]);

	useEffect(() => {
		if (!isRecalculatingDelivery) {
			previousCheckoutRef.current = props.checkout;
			return;
		}

		if (previousCheckoutRef.current !== props.checkout) {
			setRecalculatingDelivery(false);
			previousCheckoutRef.current = props.checkout;
		}
	}, [props.checkout, isRecalculatingDelivery, setRecalculatingDelivery]);

	console.log('RENDER DeliverySelect', props);

	return (
		<>
			<div className="ph-local-by-date-select-pharmacy-list-global-container">
				{props.group && (
					<div className="ph-local-by-date-select-pharmacy-list-main-container">
						<Col>
							<h4 className="ph-delivery-title">Seleccione día de entrega</h4>
						</Col>
						<Col>
							<div className="ph-local-by-date-select-pharmacy-list-delivery-select-container">
								<div>
									<div>
										<Divider style={{ marginBottom: '7px', marginTop: '1px' }}></Divider>

										<h4 className="ph-withdrawal-delivery-day-title">Día de entrega:</h4>
										{props.group.schedule_delivery && (
											<Form.Item name={`date_schedule_${props.group.name}`} rules={rulesValidation.rulesDeliveryDate}>
												<Select
													className="ph-withdrawal-personal-data-field-selector"
													style={isMobile ? { width: '100%' } : { width: '60%' }}
													size="large"
													allowClear
													placeholder="Seleccionar"
													onChange={(value) => handleDateSelected(value)}
												>
													{dateRanges.map((range, i) => {
														const label = pharmacyFeatures.sameDayDeliveryDates
															? range.start
															: `${range.start} - ${range.end}`;
														return (
															<Select.Option value={label} key={i}>
																{label}
															</Select.Option>
														);
													})}
												</Select>
											</Form.Item>
										)}
									</div>
									{timers.length >= 0 && pharmacyFeatures.deliveryTimeSelect && (
										<div>
											<h4 className="ph-withdrawal-pharmacy-local-list-item-main-title">Hora de entrega:</h4>
											<Form.Item name={`day_schedule_${props.group.name}`} rules={rulesValidation.rulesDeliveryDay}>
												<Select
													className="ph-withdrawal-pharmacy-local-selector"
													style={{ width: '100%' }}
													size="large"
													allowClear
													placeholder="Selecciona el Horario"
													onChange={(value) => handleDeliverySelect(value, props.group.name)}
												>
													{timers.map((element, index) => (
														<Select.Option value={`${element.start} - ${element.finish}`} key={index}>
															{`Horario: ${element.start} - ${element.finish} / Precio: $${props.group.payment.delivery}`}
														</Select.Option>
													))}
												</Select>
											</Form.Item>
										</div>
									)}
								</div>
							</div>
						</Col>
						<div className="ph-withdrawal-pharmacy-footer">
							<Divider style={{ marginTop: 0, marginBottom: 12 }} />

							<Row gutter={[8, 8]} align="end" wrap>
								<Col>
									<DescriptionPrices title={'Descuento:'} price={props.checkout.shipping_information.discount} />
								</Col>

									<Col>
										<DescriptionPrices
											title={'Total costo de entrega:'}
											price={(!isAddressValidated && isSelectedDeliveryType) ? '-' : isRecalculatingDelivery ? '-' : props?.checkout?.total_delivery}
										/>
									</Col>
							</Row>
						</div>
					</div>
				)}
			</div>
			<ModalLocalSelected
				isVisible={isVisible}
				isPreviewLocal={isPreviewLocal}
				userAddress={props.isUserAddress}
				handlePreviewLocal={(data) => handleModalPharmacyInfo(data)}
			/>
			<Modal
				wrapClassName="ph-checkout-local-by-date-info-modal-container"
				centered
				width={400}
				maskClosable={true}
				title={`Información sobre los Despachos a Domiclio:`}
				visible={modalHelp}
				cancelText="Cancelar"
				onCancel={() => setModalHelp(false)}
				cancelButtonProps={{ style: { display: 'none' } }}
				okButtonProps={{ style: { display: 'none' } }}
			>
				<div className="ph-checkout-local-by-date-info-delivery-main-container">
					<Images
						classContent={'ph-checkout-local-by-date-info-delivery-image-container'}
						classImage={'ph-checkout-local-by-date-info-delivery-image'}
						webp={`${ENV_IMG}/pharol-go/pharol-go-bici.webp`}
						jp2={`${ENV_IMG}/pharol-go/pharol-go-bici.jp2`}
						jxr={`${ENV_IMG}/pharol-go/pharol-go-bici.jxr`}
						default={`${ENV_IMG}/pharol-go/pharol-go-bici.png`}
						title={'Delivery'}
					/>
				</div>
				<h4 className="ph-checkout-local-by-date-info-delivery-description">
					Con el fin de brindarte un mejor servicio, habilitamos la modalidad <strong>"Despacho Express"</strong>, la cual te permitirá recibir tus pedidos
					dentro del mismo <strong>día</strong> para compras realizadas <strong>antes de las 16:00 hrs</strong> con distancias máximas de{' '}
					<strong>15 Km’s</strong>. Sólo debes seleccionar en <strong>"Día de Entrega"</strong> la opción
					<strong>"Despacho para Hoy"</strong>
				</h4>
			</Modal>
		</>
	);
}
